import React, { useState } from "react";
import './JobPostingForm.css';

const Step4 = ({ prevStep, onSubmit, setFormData }) => {
  const [questions, setQuestions] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState({
    id: null,
    text: "",
    isMandatory: false,
    type: "Single choice",
    options: [{ text: "Yes", isPreferred: true }, { text: "No", isPreferred: false }],
  });

  const suggestedQuestions = [
    
    "What’s your expected salary?",
    "What’s your notice period?",
    
    "What kind of job are you comfortable with?",
    "Have u completed training in android"
  ];

  const handleAddQuestion = () => {
    setCurrentQuestion({
      id: null,
      text: "",
      isMandatory: false,
      type: "Single choice",
      options: [{ text: "Yes", isPreferred: true }, { text: "No", isPreferred: false }],
    });
    setIsDialogOpen(true);
  };

  const handleAddSuggestedQuestion = (questionText) => {
    setCurrentQuestion({
      id: null,
      text: questionText,
      isMandatory: false,
      type: "Single choice",
      options: [{ text: "Yes", isPreferred: true }, { text: "No", isPreferred: false }],
    });
    setIsDialogOpen(true);
  };

  const handleQuestionChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCurrentQuestion((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleOptionChange = (index, field, value) => {
    const newOptions = [...currentQuestion.options];
    newOptions[index] = { ...newOptions[index], [field]: value };
    setCurrentQuestion((prev) => ({ ...prev, options: newOptions }));
  };

  const handleAddOption = () => {
    setCurrentQuestion((prev) => ({
      ...prev,
      options: [...prev.options, { text: "", isPreferred: false }],
    }));
  };

  const handleRemoveOption = (index) => {
    setCurrentQuestion((prev) => ({
      ...prev,
      options: prev.options.filter((_, i) => i !== index),
    }));
  };

  const handleSaveQuestion = () => {
    if (currentQuestion.id) {
      setQuestions(questions.map((q) => (q.id === currentQuestion.id ? currentQuestion : q)));
    } else {
      setQuestions([...questions, { ...currentQuestion, id: Date.now() }]);
    }
    setIsDialogOpen(false);
  };

  const handleDuplicateQuestion = () => {
    setQuestions([...questions, { ...currentQuestion, id: Date.now() }]);
    setIsDialogOpen(false);
  };

  const handleRemoveQuestion = (id) => {
    setQuestions(questions.filter((q) => q.id !== id));
  };

  const handleEditQuestion = (question) => {
    setCurrentQuestion(question);
    setIsDialogOpen(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormData((prev) => ({ ...prev, questions }));
    onSubmit({ questions });
    alert("Job posting submitted successfully!");
  };

  return (
    <div className="main-panel">
      <h3>Screening Questions</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Questions</label>
          <div className="questions-container">
            <button
              type="button"
              className="add-question-btn"
              onClick={handleAddQuestion}
            >
              + Add a question
            </button>
            <div className="suggested-questions">
              {suggestedQuestions.map((question) => (
                <button
                  key={question}
                  type="button"
                  className="suggestion-btn"
                  onClick={() => handleAddSuggestedQuestion(question)}
                >
                  {question}
                </button>
              ))}
            </div>
            <div className="selected-questions">
              {questions.map((question) => (
                <div key={question.id} className="question-item">
                  <span>{question.text} {question.isMandatory && <span className="mandatory">*Mandatory</span>}</span>
                  <div className="question-actions">
                    <button
                      type="button"
                      className="edit-btn"
                      onClick={() => handleEditQuestion(question)}
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      className="remove-btn"
                      onClick={() => handleRemoveQuestion(question.id)}
                    >
                      <svg viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2">
                        <path d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {isDialogOpen && (
          <div className="dialog-overlay">
            <div className="dialog-box">
              <h4>{currentQuestion.id ? "Edit Question" : "Add Question"}</h4>
              <div className="form-group">
                <label>Question</label>
                <input
                  type="text"
                  name="text"
                  value={currentQuestion.text}
                  onChange={handleQuestionChange}
                  placeholder="e.g., Have you completed training in android?"
                />
              </div>
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    name="isMandatory"
                    checked={currentQuestion.isMandatory}
                    onChange={handleQuestionChange}
                  />
                  Mandatory
                </label>
              </div>
              <div className="form-group">
                <label>Question Type</label>
                <select
                  name="type"
                  value={currentQuestion.type}
                  onChange={handleQuestionChange}
                >
                  <option value="Single choice">Single choice</option>
                  <option value="Multiple choice">Multiple choice</option>
                  <option value="Short answer">Short answer</option>
                </select>
              </div>
              {currentQuestion.type !== "Short answer" && (
                <div className="form-group">
                  <label>Answer Options</label>
                  {currentQuestion.options.map((option, index) => (
                    <div key={index} className="option-row">
                      <input
                        type="text"
                        value={option.text}
                        onChange={(e) => handleOptionChange(index, "text", e.target.value)}
                        placeholder={`Option ${index + 1}`}
                      />
                      <label>
                        <input
                          type="checkbox"
                          checked={option.isPreferred}
                          onChange={(e) => handleOptionChange(index, "isPreferred", e.target.checked)}
                        />
                        Preferred
                      </label>
                      {currentQuestion.options.length > 2 && (
                        <button
                          type="button"
                          className="remove-option-btn"
                          onClick={() => handleRemoveOption(index)}
                        >
                          <svg viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2">
                            <path d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      )}
                    </div>
                  ))}
                  <button
                    type="button"
                    className="add-option-btn"
                    onClick={handleAddOption}
                  >
                    Add another option
                  </button>
                </div>
              )}
              <div className="dialog-actions">
                <button
                  type="button"
                  className="duplicate-btn"
                  onClick={handleDuplicateQuestion}
                >
                  Duplicate
                </button>
                {currentQuestion.id && (
                  <button
                    type="button"
                    className="remove-btn"
                    onClick={() => {
                      handleRemoveQuestion(currentQuestion.id);
                      setIsDialogOpen(false);
                    }}
                  >
                    Remove
                  </button>
                )}
                <button
                  type="button"
                  className="done-btn"
                  onClick={handleSaveQuestion}
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        )}

        
      </form>
    </div>
  );
};

export default Step4;